import Swiper, { Autoplay, Navigation } from 'swiper';
import {swiperObserver} from "../../utils/swiper.utils.js";

document.querySelectorAll('.benefits-swiper-wr').forEach((el) => {
  const swiperEl = el.querySelector('.swiper');
  const nextEl = el.querySelector('.swiper-button-next');
  const prevEl = el.querySelector('.swiper-button-prev');

  if (!swiperEl) {
    return;
  }

  const benefitsTitlesArr = swiperEl.querySelectorAll('.benefit-card__title');

  let swiper = new Swiper(swiperEl, {
    modules: [Autoplay, Navigation],
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    spaceBetween: 12,
    speed: 500,
    threshold: 10,
    navigation: {
      nextEl,
      prevEl,
    },
    breakpoints: {
      641: {
        spaceBetween: 16,
        slidesPerView: 2,
      },
      961: {
        spaceBetween: 16,
        slidesPerView: 3,
      },
      1100: {
        spaceBetween: 16,
        slidesPerView: 4,
      },
      1200: {
        spaceBetween: 21,
        slidesPerView: 4,
      }
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: window.innerWidth >= 1033,
    },
  });

  swiperObserver(swiper);

  if(benefitsTitlesArr.length) {
    window.lineTitlesFunc(benefitsTitlesArr);
  }
});
